<template>
  <!-- 商户登录 -->
  <div class="intent">
    <Banner :list="bannerList" :height="186" :showBtn="false" class="head-banner"></Banner>

    <div class="intent-block urge-block" v-if="userInfo">
      <div class="intent-title">
        <span><img src="@/../static/title_left.png"></span>
        欢迎您
        <span><img src="@/../static/title_right.png"></span>
      </div>
      <div style="text-align: center;font-size: 16px;font-weight: bold;">
        {{userInfo.username}}
      </div>

      <div class="control-block row button-block">
        <button type="button" class="button button-primary" @click="handleScan">扫码</button>
      </div>
    </div>

    <div class="intent-block urge-block" v-else>
      <div class="intent-title">
        <span><img src="@/../static/title_left.png"></span>
        商户登录
        <span><img src="@/../static/title_right.png"></span>
      </div>
      <div class="control-block row">
        <div class="control-label">
          帐号：
        </div>
        <div class="control-input">
          <input type="text" v-validate="'required'" name="username" class="form-control" placeholder="请输入帐号"
            v-model="loginForm.username" />
          <span v-show="errors.has('username')" class="error-text">{{errors.first('username')}}</span>
        </div>
      </div>

      <div class="control-block row">
        <div class="control-label">
          密码：
        </div>
        <div class="control-input">
          <input type="password" name="loginPwd" v-validate="'required'|'loginPwd'" class="form-control"
            placeholder="请输入密码" v-model="loginForm.password" />
          <span v-show="errors.has('loginPwd')" class="error-text">{{errors.first('loginPwd')}}</span>

        </div>
      </div>

      <div class="control-block row">
        <div class="control-label">
          验证码：
        </div>
        <div class="control-input">
          <input type="text" name="code" v-validate="'required|code'" class="form-control" placeholder="请输入验证码"
            v-model="loginForm.code" />

          <span v-show="errors.has('code')" class="error-text">{{errors.first('code')}}</span>

        </div>
      </div>
      <div class="control-block row">
        <div class="control-label"></div>
        <div class="control-input">
          <img :src="codeImg" @click="changeCode" title="图片看不清？点击重新得到验证码" style="cursor:pointer;margin-top: -4px;"
            width="116" height="34" />
        </div>
      </div>


      <van-loading v-if="isLoading" size="20">登录中...</van-loading>
      <div class="control-block row button-block">
        <button type="button" :disabled="isLoading" class="button button-primary" @click="handleLogin">登录</button>
      </div>
    </div>

    <div class="modal" v-if="showModal">
      <div class="intent-block modal-content">
        <div class="item">
          <div class="label">姓名</div>
          <div class="value">{{scanUser.username}}</div>
        </div>
        <div class="item">
          <div class="label">手机号</div>
          <div class="value">{{scanUser.mobile}}</div>
        </div>
        <div class="item">
          <div class="label">证件号</div>
          <div class="value">{{scanUser.cardNumber}}</div>
        </div>
        <div class="item" v-if="scanUser.hasVerify == '0'">
          <div class="label">核验状态</div>
          <div class="value" style="color: #137cd7;">待核验</div>
        </div>
        <div class="item" v-if="scanUser.hasVerify == '1'">
          <div class="label">核验状态</div>
          <div class="value" style="color: red;">已核验</div>
        </div>
        <div class="item" v-if="scanUser.hasVerify == '1'">
          <div class="label">核验时间</div>
          <div class="value">{{formatTime()}}</div>
        </div>
        <div class="control-block row button-block" v-if="scanUser.hasVerify == '0'">
          <button type="button" :disabled="isLoading" class="button button-primary"
            @click="handleVerifyConfirm">核验</button>
        </div>
      </div>
      <div class="control-block row button-block">
        <button type="button" :disabled="isLoading" class="button button-primary" @click="showModal=false">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    MessageBox,
    Toast
  } from "mint-ui"
  import wx from "weixin-js-sdk"
  import Banner from "../components/MobileBanner"
  import moment from 'moment'
  export default {
    components: {
      Banner
    },
    data() {
      return {
        isLoading: false,
        bannerList: [{
          mobileImageUrl: "/abc/static/banner.png"
        }],
        code: '',
        openId: '',
        wechatReady: false,
        userInfo: undefined,
        loginForm: {
          username: '',
          password: '',
          code: ''
        },
        showModal: false,
        scanUser: undefined,
        codeImg: '/bicycle/captcha/kaptcha.jpg',
        appId: '',
        userId: '',

      }
    },
    mounted() {
      this.openId = localStorage.getItem("openId")
      this.getWechatSign();
      wx.ready(function() {

      });
      wx.error(function(res) {
        console.log(res)
        MessageBox.alert("微信环境初始化失败");
      });

      document.title = "商户登录";
    },
    methods: {
      formatTime() {
        return moment(Number(this.scanUser.verifyTime)).format("YYYY-MM-DD HH:mm:ss")
      },
      changeCode: function() {
        this.codeImg = '/bicycle/captcha/kaptcha.jpg?' + new Date().getTime()
      },
      getWechatSign: function() {
        const self = this;
        let url = location.href;
        console.log("url" + url);
        let encodeUrl = encodeURIComponent(url);
        this.$http.get("/bicycle/inter/getWechatSign?url=" + encodeUrl).then(function(res) {
          if (res.data.status != 200) {
            MessageBox.alert(res.data.errorMsg);
          } else {
            let e = res.data.data;

            if (self.$route.query.code) {
              self.code = self.$route.query.code;
              self.appId = e.appId
              wx.config({
                debug: false, // 关闭调试模式
                appId: e.appId, // 必填，公众号的唯一标识
                timestamp: e.timestamp, // 必填，生成签名的时间戳
                nonceStr: e.nonceStr, // 必填，生成签名的随机串
                signature: e.signature, // 必填，签名
                jsApiList: [
                  "scanQRCode", 'updateAppMessageShareData', 'onMenuShareTimeline'
                ], // 必填
                openTagList: ['wx-open-subscribe']
              });

              //获取openId
              if (!self.openId) {
                self.getOpenId();
              } else {
                self.wechatReady = true;
                self.getMyInfo()
              }


              history.pushState({}, document.title, url);
            } else {
              let currentUrl = location.href;
              let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + e.appId +
                "&redirect_uri=" + encodeURIComponent(currentUrl) +
                "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
              window.location.href = redirectUrl;
            }
          }
        }).catch(function(error) {
          console.log(error)
        });
      },
      getOpenId: function() {
        const self = this;
        self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res) {
          if (res.data.status != 200) {
            if (res.data.errorMsg.indexOf("Code已过期") >= 0) {
              let currentUrl = location.origin + location.pathname;
              console.log(currentUrl)
              let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + self.appId +
                "&redirect_uri=" + encodeURIComponent(currentUrl) +
                "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
              window.location.href = redirectUrl;
              return
            }
            MessageBox.alert(res.data.errorMsg);
          } else {
            self.openId = res.data.data;
            self.wechatReady = true;
            self.getMyInfo(); //获取我的商户信息
          }
        }).catch(function(error) {
          console.log(error)
        });
      },
      handleVerifyConfirm() {
        const self = this
        MessageBox.confirm('确定要核验吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.handleVerify()
        }).catch(() => {

        })
      },
      handleVerify() {
        const self = this;

        self.isLoading = true
        self.$http.get("/bicycle/inter/coupon/doVerify?openId=" + self.openId + "&userId=" + self.userId).then(function(
          res) {
          self.isLoading = false
          if (res.data.status == 200) {
            const t = JSON.parse(JSON.stringify(self.scanUser))
            t.hasVerify = "1"
            t.verifyTime = new Date().getTime()
            self.scanUser = t
            MessageBox.alert("核验成功");
          } else {
            MessageBox.alert(res.data.errorMsg);
          }
        }).catch(function(err) {
          self.isLoading = false
          console.log(err)
        })
      },
      getMyInfo: function() {
        const self = this
        this.$http.post("/bicycle/inter/getMyInfo", {
          openId: this.openId
        }).then(function(res) {
          if (res.data.status == 200) {
            //已绑定账户，直接显示
            self.userInfo = res.data.data
          }
        }).catch(function(error) {

        })
      },
      handleLogin: function() {

        const params = {
          username: this.loginForm.username,
          password: this.loginForm.password,
          openId: this.openId,
          captchaCode: this.loginForm.code
        }
        console.log(params)
        try {
          const self = this
          this.$validator.validate().then(valid => {
            if (valid) {
              self.isLoading = true

              self.$http.post("/bicycle/inter/login", params).then(function(res) {
                self.isLoading = false
                if (res.data.status == 200) {
                  self.userInfo = res.data.data
                }
              }).catch(function(err) {
                console.log(err)
                self.isLoading = false
              })
            }
          })
        } catch (err) {

        }
      },
      handleScan() {
        const self = this
        wx.scanQRCode({
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: function(res) {
            console.log('进入结果')
            // const result = res.resultStr
            const result = "INTENT:12385"
            if (result.indexOf("INTENT:") >= 0) {
              const userId = result.split(":")[1]
              self.userId = userId
              self.$http.post("/bicycle/inter/storeGetUser", {
                openId: self.openId,
                userId: userId
              }).then(function(res) {
                if (res.data.status == 200) {
                  self.scanUser = res.data.data
                  self.showModal = true
                } else {
                  MessageBox.alert(res.data.errorMsg);
                }
              }).catch(function(err) {
                MessageBox.alert("系统错误");
              })
            } else {
              MessageBox.alert("不是赛事平台二维码");
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .modal-content {
    width: calc(100vw - 72px);
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .modal-content .item {
    display: flex;

  }

  .modal-content .item .label {
    font-size: 14px;
    width: 100px;
    font-weight: bold;
  }

  .modal-content .item .value {
    font-size: 14px;
  }

  .step-img {
    padding: 27px 42px;
  }

  .step-img img {
    width: 100%;
  }

  .intent-title {
    text-align: center;
    color: rgb(19, 124, 215);
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 25px;
  }

  .control-block {
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .control-label {
    color: rgb(102, 102, 102);
    font-size: 15px;
    float: left;
    width: 30%;
  }

  .control-input {
    width: 70%;
  }

  .form-control {
    border: 1px solid rgb(229, 229, 229);
    border-radius: 6px;
    height: 38px;
    color: rgb(51, 51, 51);
    font-size: 15px;
    padding: 0 14px;
    width: 100%;
    background: #fff;
  }

  .radio-inline {
    padding: 0 0;
    display: flex;
    align-items: center;
  }

  .radio-row {
    padding: 0 0;
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 7px 0;
  }

  .radio-row label {
    margin-left: 14px;
    padding: 7px 0;
  }

  .radio-inline input {
    margin-left: 14px;
  }

  .add {
    justify-content: start;
    margin-top: 35px
  }

  input,
  select,
  textarea {
    box-sizing: border-box;
  }

  textarea {
    min-height: 60px;
  }

  .button-block {
    margin-top: 35px;
  }

  .button-add:active {
    opacity: 0.7;
  }

  .order-height {
    height: 74px;
  }

  .order-block {
    background-color: #FFF;
    height: 64px;
    box-shadow: 2px -2px 5px #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }


  .error-text {
    color: red;
    padding-left: 12px;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MobileStore.vue